import React from 'react';

import CSS from './styles.scss';

import { ItemEdit as IEIcon } from 'Shared/Icons';
import { Trash as TRIcon } from 'Shared/Icons';


const EditNoteOptionsViews = ({ openNoteEditor, removeNote }) => {
  return (
    <div className={ CSS['container'] }>
      <button className={ CSS['edit-note'] } onClick={ openNoteEditor }>
        <IEIcon fill="#ffffff" />
        <span className={ CSS['edit-note__text'] }>Edit Note</span>
      </button>

      <button className={ CSS['remove-note'] } onClick={ removeNote }>
        <TRIcon fill="#ffffff" />
        <span className={ CSS['remove-note__text'] }>Remove Note</span>
      </button>
    </div>
  );
}


export default EditNoteOptionsViews;
